import Image from "next/image";

export default function CloseIcon() {
  return (
    <Image src="/i/dialog_close_icon.svg" alt="close" width={14} height={14} />
  );
}
